'use strict';

var settingsModule = angular.module('t2g.settings', [
  'gettext',
  'ui.router',
  require('t2g.common.services.industrySpecificService').name,
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.notificationService').name,
]);

module.exports = settingsModule;

settingsModule.controller('SettingsCtrl', require('./settingsCtrl'));

settingsModule.config(function($stateProvider) {
  $stateProvider.state('private.main.settings', {
    url: '/settings',
    title: 'Settings',
    templateUrl: '/app/modules/settings/SettingsView.html?v=4.5.6',
    controller: 'SettingsCtrl',
    resolve: {
      officeResolve: function(OfficeDA) {
        return OfficeDA.get();
      },
      employees: function(ResourceDA) {
        return ResourceDA.list('employee').then(function(resources) {
          return _.filter(resources.resources, { type: 'employee' });
        });
      },
    },
  });
});



// WEBPACK FOOTER //
// ./src/app/modules/settings/settingsModule.js